import { render, staticRenderFns } from "./HeatmapView.vue?vue&type=template&id=3afaa8d9"
import script from "./HeatmapView.vue?vue&type=script&lang=js"
export * from "./HeatmapView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports